import { Component } from '@angular/core';

@Component({
  selector: 'update',
  template: ''
})

export class UpdateComponent {
  constructor() {
    window.location.replace(`${window.location.origin}/update/`);
  }

}
